import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const Header = () => {
  const { cart } = useCart();
  return (
    <>


      {/* Navbar */}
      <div className="container-fluid fixed-top px-0 wow fadeIn" data-wow-delay="0.1s">
        <div className="top-bar row gx-0 align-items-center d-none d-lg-flex">
          <div className="col-lg-6 px-5 text-start">
            <small><i className="fa fa-map-marker-alt me-2"></i>579 Kerr St Unit 4, Ontario, CA </small>
            <small className="ms-4"><i className="fa fa-envelope me-2"></i>info@organiquejuicebar.ca</small>
          </div>
          <div className="col-lg-6 px-5 text-end">
            <small>Follow us:</small>
             {/*<a className="text-body ms-3" href=""><i className="fab fa-facebook-f"></i></a>
            <a className="text-body ms-3" href=""><i className="fab fa-twitter"></i></a>
            <a className="text-body ms-3" href=""><i className="fab fa-linkedin-in"></i></a>*/}
            <a className="text-body ms-3" href="https://www.instagram.com/organiquejuicebar.oakville"><i className="fab fa-instagram"></i></a>
          </div>
        </div>

        <nav className="navbar navbar-expand-lg navbar-dark navbar-orange py-lg-0 px-lg-5 wow fadeIn" data-wow-delay="0.1s">
          <Link to="/" className="navbar-brand ms-4 ms-lg-0">
            <h1 className="fw-bold m-0">Organique <span>Juice </span>Bar</h1>
          </Link>
          <button type="button" className="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto p-4 p-lg-0">
              <Link to="/" className="nav-item nav-link active">Home</Link>
              <Link to="/menu" className="nav-item nav-link">Menu</Link>
              {/*
              <Link to="/about" className="nav-item nav-link">About Us</Link>
              <div className="nav-item dropdown">
                <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">Pages</a>
                <div className="dropdown-menu m-0">
                  <Link to="/blog" className="dropdown-item">Blog Grid</Link>
                  <Link to="/features" className="dropdown-item">Our Features</Link>
                  <Link to="/testimonial" className="dropdown-item">Testimonial</Link>
                </div>
              </div>*/}
              <a href="#footer" className="nav-item nav-link">Contact Us</a>
            </div>
            <div className="d-none d-lg-flex ms-2">
              {/* <a className="btn-sm-square bg-white rounded-circle ms-3" href="">
                <small className="fa fa-search text-body"></small>
              </a>
              <a className="btn-sm-square bg-white rounded-circle ms-3" href="">
                <small className="fa fa-user text-body"></small>
              </a>
              <Link className="btn-sm-square bg-white rounded-circle ms-3 position-relative" to="/cart">
                <small className="fa fa-shopping-bag text-body"></small>
                {cart.length > 0 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {cart.reduce((total, item) => total + item.quantity, 0)}
                  </span>
                )}
              </Link> */}
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;